import getRadiologistPerformance from "@custom/rtk-apis/analytics/getRadiologistPerformance";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getRadiologistPerformanceSlice = createSlice({
  name: "getRadiologistPerformanceSlice",
  initialState,
  reducers: {
    clearRadiologistPerformance: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRadiologistPerformance.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRadiologistPerformance.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.data;
        state.msg = payload.message;
      })
      .addCase(getRadiologistPerformance.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getRadiologistPerformanceSlice.reducer;
export const { clearRadiologistPerformance } = getRadiologistPerformanceSlice.actions;
